import React from 'react';

import { InvestVideoPanel } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const InvestVideoPanelPage = props => (
  <InvestVideoPanel {...props} notificationApi={notificationApi} />
);
